'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ConfigPage$() {
}
export { $c_Lpresto_ConfigPage$ as $c_Lpresto_ConfigPage$ };
$p = $c_Lpresto_ConfigPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ConfigPage$;
/** @constructor */
function $h_Lpresto_ConfigPage$() {
}
export { $h_Lpresto_ConfigPage$ as $h_Lpresto_ConfigPage$ };
$h_Lpresto_ConfigPage$.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1470118639);
});
$p.l = (function() {
  return "ConfigPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "ConfigPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_ConfigPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ConfigPage$, "presto.ConfigPage$", ({
  EU: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_ConfigPage$ as $d_Lpresto_ConfigPage$ };
var $n_Lpresto_ConfigPage$;
function $m_Lpresto_ConfigPage$() {
  if ((!$n_Lpresto_ConfigPage$)) {
    $n_Lpresto_ConfigPage$ = new $c_Lpresto_ConfigPage$();
  }
  return $n_Lpresto_ConfigPage$;
}
export { $m_Lpresto_ConfigPage$ as $m_Lpresto_ConfigPage$ };
//# sourceMappingURL=presto.-Config-Page$.js.map
